import React from 'react'
import UserProfile from '../Auth/UserProfile'


const EditStaff = (props: any) => {
  const { profile } = props

  return (
    <>
      <UserProfile
        profile={profile}
      />
    </>
  )
}

export default EditStaff
